import React, { useState } from 'react';
import { Select, Radio, Row, Col } from 'antd';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { landlordReconciliationPreference } from 'common/constants/landlord';
import { reconciliationOption, reconciliationFrequencies } from '~constants/landlord';

import Modal from 'common/components/modal';
import useStyles from '../../style';
import { getSafeHtml } from 'common/helpers/safeHtml';

const EditReconciliationModal = props => {
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const classes = useStyles();

  const { visible, onCancel, form, landlord, updateLandlord, getLandlord } = props;
  const { getFieldDecorator, validateFields, resetFields } = form;

  const handleCancel = () => {
    onCancel();
    resetFields([
      'bookingAutoConfirm',
      'reconciliationFrequency',
      'reconciliationOption',
      'reconciliationPreference',
    ]);
  };
  const onOk = () => {
    validateFields((error, values) => {
      if (!error) {
        const {
          bookingAutoConfirm,
          reconciliationFrequency,
          reconciliationOption,
          reconciliationPreference,
        } = values;
        setLoading(true);
        updateLandlord(
          {
            id: landlord.id,
            bookingAutoConfirm,
            reconciliationFrequency,
            reconciliationOption,
            reconciliationPreference,
          },
          () => {
            setLoading(false);
            onCancel();
            getLandlord();
          },
          () => {
            setLoading(false);
          },
        );
      }
    });
  };

  return (
    <>
      <Modal
        title={t('cms.landlord.modal.title.edit_reconciliation_setting')}
        width={850}
        visible={visible}
        okText={t('cms.properties.edit.leave_alert.title')}
        cancelText={t('cms.landlord.modal.cancel.button')}
        wrapClassName={classes.modalWrapper}
        onCancel={handleCancel}
        onOk={onOk}
        cancelButtonProps={{
          className: 'ant-btn-cancel',
        }}
        okButtonProps={{
          loading,
          className: 'ant-btn-confirm',
        }}
      >
        <Form className={classes.formWrapper}>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label={t('cms.landlord.detail.reconciliation_preference.label')}>
                {getFieldDecorator('reconciliationPreference', {
                  initialValue:
                    landlordReconciliationPreference.length > 0
                      ? landlord.reconciliationPreference || DEFAULT_RECONCILIATION_PREFERENCE
                      : undefined,
                })(
                  <Select
                    placeholder={t('cms.landlord.detail.reconciliation_preference.placeholder')}
                  >
                    <For of={landlordReconciliationPreference} each="option" index="index">
                      <Select.Option key={index} value={option}>
                        {t(`cms.landlord.modal.${option.toLowerCase()}.option`)}
                      </Select.Option>
                    </For>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label={t('cms.landlord.detail.reconciliation_frequency.label')}>
                {getFieldDecorator('reconciliationFrequency', {
                  rules: [
                    {
                      required: true,
                      message: t('cms.landlord.modal.error.blank'),
                    },
                  ],
                  initialValue: landlord.reconciliationFrequency || undefined,
                })(
                  <Select
                    placeholder={t('cms.landlord.detail.reconciliation_frequency.placeholder')}
                  >
                    <For of={reconciliationFrequencies} each="option" index="index">
                      <Select.Option key={index} value={option}>
                        {t(`cms.landlord.modal.${option.toLowerCase()}.option`)}
                      </Select.Option>
                    </For>
                  </Select>,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            className="reconciliation-settings__option"
            label={t('cms.landlord.detail.reconciliation_option.label')}
          >
            {getFieldDecorator('reconciliationOption', {
              rules: [
                {
                  required: true,
                  message: t('cms.landlord.modal.error.blank'),
                },
              ],
              initialValue: landlord.reconciliationOption || undefined,
            })(
              <Select placeholder={t('cms.landlord.detail.reconciliation_option.placeholder')}>
                <For of={reconciliationOption} each="option" index="index">
                  <Select.Option key={index} value={option}>
                    {t(`cms.landlord.modal.reconciliation_option.${option.toLowerCase()}.option`)}
                  </Select.Option>
                </For>
              </Select>,
            )}
          </Form.Item>
          <div className="reconciliation-settings__notice">
            {getSafeHtml(t('cms.landlord.modal.reconciliation_settings.notice'))}
          </div>
          <Form.Item label={t('cms.landlord.detail.booking_auto_confirm.label')}>
            {getFieldDecorator('bookingAutoConfirm', {
              rules: [
                {
                  required: true,
                  message: t('cms.landlord.modal.error.blank'),
                },
              ],
              initialValue: !!landlord.bookingAutoConfirm,
            })(
              <Radio.Group>
                <Radio value={true}>
                  <span className="landlord-info__radio-text">{t('cms.form.value.yes')}</span>
                </Radio>
                <Radio value={false}>{t('cms.form.value.no')}</Radio>
              </Radio.Group>,
            )}
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
EditReconciliationModal.propTypes = {
  form: PropTypes.object.isRequired,
  landlord: PropTypes.object.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  reconciliationPreference: PropTypes.array,
};
export default Form.create()(EditReconciliationModal);
